import { isStaff as userIsStaff } from 'utils/currentUser';

import { useCurrentUser } from './useCurrentUser';

export function useCurrentUserIsStaff() {
  const currentUser = useCurrentUser();
  return currentUser ? userIsStaff(currentUser) : false;
}
